import { RouteRecordRaw } from 'vue-router'
import { prefixLanguage } from '@utils/urls'
import type { Options } from '@/router'
import { prefixRoutes } from '@router/utils'

import {
  createRoutes as createCabinetRoutes,
  createStaffCabinetRoutes,
} from '@m/cabinet/router'
import { accessPermission } from '@/modules/user/permissions'
import { IS_ADMINISTRATOR } from '@/modules/user/accessTokens'

export default function createInitialRoutes(
  options: Options
): RouteRecordRaw[] {
  return [
    prefixRoutes(prefixLanguage('/staff/'), createStaffCabinetRoutes(options), {
      meta: {
      },
    }),
    prefixRoutes(prefixLanguage('/cabinet/'), createCabinetRoutes(options)),
    // { path: '/:pathMatch(.*)*', name: 'NotFound', redirect: { path: '/404/' } },
  ]
}
